import request from '../util/request';

function setUrlParam(data) {
  let _str = '';
  for (let i in data) {
    if (!isNull(data[i])) {
      _str += i + '=' + encodeURIComponent(data[i]) + '&';
    }
  }
  return '?' + _str.substring(0, _str.length - 1);
}

function isNull(e) {
  let _ = String(e);
  return (_ === 'null' || _ === 'NaN' || _ === 'undefined' || _.length === 0);
}


const api = {
  /*loginPlatform(data) {
    return request({
      url: '/loginPlatform' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      // data:data,
    })
  },*/
  weatherjson(data) {
    return request({
      // url: 'http://111.9.253.19:8090/weatherkit/weatherjson/' + data,
      url: 'https://zylsweather.lintrondata.com/weatherkit/weatherjson/' + data,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'get',
      // data:data,
    })
  },
  getBanner(data) { //获取banner列表
    return request({
      url: '/api/banner/getBanner',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getAppMenuList(data) { //获取菜单列表
    return request({
      url: '/api/menu/getAppMenuList' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
      // data:data,
    })
  },
  getMapSiteList(data) { //获取周边站点信息列表
    return request({
      url: '/api/map/site/getMapSiteList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getInfoContentList(data) { //分页获取信息发布列表
    //holiday 节日节庆 culture_local 民俗风情 culture_folkways 民俗风情 culture_famous 人文风范 culture_historical 历史大观
    // activity_info 旅游资讯 activity_tourism 文旅活动 xtgg 系统公告 yxhd 营销活动 ykbz 游客帮助 wzms 网站描述  zwgg 政务公告

    return request({
      url: '/api/info/content/getInfoContentList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getInfoContentDetail(data) { //获取信息发布详情
    return request({
      url: '/api/info/content/getInfoContentDetail' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getSellerList(data) { //获取商家列表 seller_type_spot 景区 seller_type_hotel 酒店 seller_type_dutyfree 免税店 seller_type_ house 民宿 seller_type_restaurant 餐馆
    return request({
      url: '/api/seller/getSellerList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getGroupList(data) { //获取旅游线路(攻略)列表  groupType	路线类型(攻略：1、路线：2)
    return request({
      url: '/api/group/getGroupList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getGroupDetail(data) { //获取旅游线路(攻略)详情
    return request({
      url: '/api/group/getGroupDetail' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'post',
    })
  },
  getBaseAreaInfo(data) { //大美滨海信息获取接口
    return request({
      url: '/api/area/getBaseAreaInfo' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
    })
  },
  getVideoList(data) { //5g视频分类
    return request({
      url: '/api/info/video/getVideoList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getByTypeCodeSellers(data) { //精选美图接口(t通过商家类型编码获取商家列表)
    return request({
      url: '/api/seller/getByTypeCodeSellers',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getRatingList(data) { //获取评价列表
    return request({
      url: '/api/unlogin/getRatingList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getById(data) { //视频详情
    return request({
      url: '/api/info/video/getById/'+data,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET'
    })
  },
  addCollect(data) { //添加收藏
    // VIDEO(1, "视频"), VR(2, "VR"), JRJQ(3, "节日节庆"),  HDZX(5, "活动资讯"), ZWGG(6, "政务公告"), GLLX(7, "攻略路线"), MALL(8, "商家"), COMMITY(9, "商品"), SQ(10, "商圈");
    return request({
      url: '/api/user/collect/addCollect' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  addRating(data) { //添加评论
    //( 商家：1、 节日节庆：2、 商圈：3)
    return request({
      url: '/api/user/rating/addRating' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getSosInfoList(data) { //获取安全求助信息列表
    return request({
      url: '/api/info/informationSos/getSosInfoList' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getTouristCentreList(data) { //分页获取游客中心列表
    return request({
      url: '/api/info/informationTouristCentre/getTouristCentreList' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getTrafficInfo(data) { //获取交通出行信息列表
    return request({
      url: '/api/info/informationTraffic/getTrafficInfo',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  returnUerInfo(data) { //返回用户信息
    return request({
      url: '/api/user/returnUerInfo',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'post',
    })
  },
  getCbdList(data) { //获取商圈列表
    return request({
      url: '/api/mallCbd/getCbdList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getCbdDetail(data) { //获取商圈详情
    return request({
      url: '/api/mallCbd/getCbdDetail' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getSellerDetail(data) { //获取商家详情
    return request({
      url: '/api/seller/getSellerDetail' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getCommodityList(data) { //获取商品列表
    return request({
      url: '/api/mallCommodity/getCommodityList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getSellerTypeList(data) { //获取商家分类列表
    return request({
      url: '/api/sellerType/getSellerTypeList' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  delCollect(data) { //批量删除收藏
    return request({
      url: 'api/user/collect/delCollect' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getGroupListByTagCode(data) { //通过标签编码获取旅游路线列表
    return request({
      url: '/api/group/getGroupListByTagCode' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getConsultsReplyListByPage(data) { //获取用户咨询列表及回复详情(分页)
    return request({
      url: '/api/user/consults/getConsultsReplyListByPage' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  addConsults(data) { //添加咨询
    return request({
      url: '/api/user/consults/addConsults' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getCommodityDetail(data) { //商品详情
    return request({
      url: '/api/mallCommodity/getCommodityDetail' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  addComplain(data) { //添加投诉内容
    return request({
      url: '/api/user/complaint/addComplain' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getCollectList(data) { //获取收藏列表
    return request({
      url: '/api/user/collect/getCollectList' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  delConsults(data) { //批量删除咨询
    return request({
      url: '/api/user/consults/delConsults' ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getConsultsDetail(data) { //获取咨询详情
    return request({
      url: '/api/user/consults/getConsultsDetail' + setUrlParam(data) ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
      // data:data,
    })
  },
  getConsultsReplyList(data) { //获取咨询列表不分页
    return request({
      url: '/api/user/consults/getConsultsReplyList' + setUrlParam(data) ,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      // data:data,
    })
  },
  searchAll(data) { //搜索商家、商品、商圈列表
    return request({
      url: '/api/common/searchAll?searchName=' + data,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
      // data:data,
    })
  },
  getSeachLabel(data) { //搜索热词
    return request({
      url: '/api/baseSearchLabel/getSeachLabel',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
      // data:data,
    })
  },
  loginByUniUser(data) { //注册我们的用户
    return request({
      url: '/api/user/loginByUniUser',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  modifyInfo(data) { //修改用户信息
    return request({
      url: '/api/user/center/modifyInfo',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  uploadHeadPortrait(data) { //上传头像
    return request({
      url: '/api/user/center/uploadHeadPortrait',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getLatestByColumnCode(code) { //上传头像
    return request({
      url: '/api/info/content/getLatestByColumnCode/'+code,
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
    })
  },
  getqueryPage(data) { //旅行社列表
    return request({
      url: '/api/info/business/queryPage',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'POST',
      data:data,
    })
  },
  getLivelist(){ //直播接口
    return request({
      url: '/api/info/video/getMonitorList',
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',

    })
  },
  getinformationActivityTopicList(data){ //活动专题 总list 接口
    return request({
      url: '/informationActivityTopic/searchPage'+ setUrlParam(data) ,
      method: 'GET',
    })
  },
  getInformationActivityTopicTypeList(data){ //活动专题 每个专题的list接口
    return request({
      url: '/informationActivityTopic/find/'+data,
      method: 'GET',

    })
  },
  trafficStation(data) { //新交通分页查询
    return request({
      url: '/trafficStation/searchPage' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
    })
  },
  hotelDirectory(data) { //酒店名录
    return request({
      url: '/hotelDirectory/searchPage' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
    })
  },
  marketDirectory(data) { //商场名录
    return request({
      url: '/marketDirectory/searchPage' + setUrlParam(data),
      // ContentType: 'application/json;charset=UTF-8',
      method: 'GET',
    })
  },
};

export default api;
